// Bundle P-1 — thin wrappers around navigator.credentials. No dependency; base64url is the only encoding WebAuthn needs.

export const b64urlToBuf = (s) => Uint8Array.from(atob(s.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(s.length / 4) * 4, "=")), (c) => c.charCodeAt(0)).buffer;
export const bufToB64url = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

export const passkeysSupported = () => typeof window !== "undefined" && !!window.PublicKeyCredential && !!navigator.credentials;

export function defaultPasskeyName() {
  const ua = navigator.userAgent || "";
  if (/iPhone/.test(ua)) return "iPhone";
  if (/iPad/.test(ua)) return "iPad";
  if (/Macintosh/.test(ua)) return "MacBook";
  if (/Windows/.test(ua)) return "Windows Hello";
  if (/Android/.test(ua)) return "Android phone";
  return "Passkey";
}

const decodeOptions = (o) => ({
  ...o,
  challenge: b64urlToBuf(o.challenge),
  ...(o.user ? { user: { ...o.user, id: b64urlToBuf(o.user.id) } } : {}),
  ...(o.excludeCredentials ? { excludeCredentials: o.excludeCredentials.map((c) => ({ ...c, id: b64urlToBuf(c.id) })) } : {}),
  ...(o.allowCredentials ? { allowCredentials: o.allowCredentials.map((c) => ({ ...c, id: b64urlToBuf(c.id) })) } : {}),
});

const encodeCredential = (cred, extra) => ({
  id: cred.id, rawId: bufToB64url(cred.rawId), type: cred.type,
  clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
  authenticatorAttachment: cred.authenticatorAttachment || undefined,
  response: { clientDataJSON: bufToB64url(cred.response.clientDataJSON), ...extra(cred.response) },
});

export async function createPasskey(options) {
  const cred = await navigator.credentials.create({ publicKey: decodeOptions(options) });
  return encodeCredential(cred, (r) => ({
    attestationObject: bufToB64url(r.attestationObject),
    transports: r.getTransports ? r.getTransports() : [],
  }));
}

export async function getPasskey(options) {
  const cred = await navigator.credentials.get({ publicKey: decodeOptions(options) });
  return encodeCredential(cred, (r) => ({
    authenticatorData: bufToB64url(r.authenticatorData), signature: bufToB64url(r.signature),
    userHandle: r.userHandle ? bufToB64url(r.userHandle) : null,
  }));
}

export function friendlyWebAuthnError(err) {
  const name = err?.name || "";
  if (name === "NotAllowedError" || name === "AbortError") return "Cancelled — no passkey was used.";
  if (name === "InvalidStateError") return "This device already has a passkey for your account.";
  if (name === "NotSupportedError" || name === "SecurityError") return "Passkeys aren't available in this browser.";
  return err?.response?.data?.detail || "Something went wrong with the passkey. Please try again.";
}
